import { CanActivateFn } from '@angular/router';

export const forgotPasswordGuard: CanActivateFn = (route, state) => {
  if(sessionStorage?.getItem('token')) return false
  if(sessionStorage?.getItem('forgotToken') && sessionStorage?.getItem('isForgot')) return true
  return false;
};
